import type { Ad } from '@/features/meta-ads/api/types';
import { ImageOff } from 'lucide-react';
import { useState } from 'react';

export function AdThumbnail({
  ad,
  large = false,
}: {
  ad: Ad;
  large?: boolean;
}) {
  const thumbnailUrl =
    ad.graphicImageUrl || ad.video?.thumbnailUrl || ad.metaThumbnailUrl;
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const size = large ? 'size-14 rounded-lg' : 'size-10 rounded';

  // Bind the failure to its URL so a refreshed preview can load immediately.
  if (thumbnailUrl && failedUrl !== thumbnailUrl) {
    return (
      <img
        alt={ad.name}
        className={`${size} shrink-0 object-cover`}
        onError={() => setFailedUrl(thumbnailUrl)}
        src={thumbnailUrl}
      />
    );
  }

  const label = `Preview unavailable for ${ad.name}`;
  return (
    <div
      aria-label={label}
      className={`flex ${size} shrink-0 items-center justify-center bg-muted`}
      role="img"
      title={label}
    >
      {thumbnailUrl ? (
        <ImageOff aria-hidden className="size-4 text-muted-foreground" />
      ) : (
        <span className="text-muted-foreground text-xs">No img</span>
      )}
    </div>
  );
}
